import { status } from '../../config.ts'
import {
  passwordResetRequest,
  updatePassword,
  verifyResetCode
} from '@/__mocks__/modules/recovery/data.ts'
import { wait } from '@/__mocks__/util/async.ts'

export default [
  {
    method: 'POST',
    path: '/password-reset-request',
    reply: async () => {
      await wait()
      return [status.ok, passwordResetRequest]
    }
  },
  {
    method: 'POST',
    path: '/verify-reset-code',
    reply: async () => {
      await wait()
      return [status.ok, verifyResetCode]
    }
  },
  {
    method: 'POST',
    path: '/update-password',
    reply: async () => {
      await wait()
      return [status.ok, updatePassword]
    }
  }
]
